function evaluateDecisionTree(node, data) {
  if (typeof node === 'function') return node()
  if (typeof node !== 'object')
    throw new Error('Invalid node type encountered in evaluateDecisionTree()')

  for (const condition in node) {
    if (data[condition]) {
      return evaluateDecisionTree(node[condition], data)
    }
  }
}

const getTollFreeData = function (state) {
  const { tollFreeStatus } = state
  const REQUIRED = 'REQUIRED'

  return function (sid: string, phoneNumber: string) {
    if (!sid || !phoneNumber)
      return {
        status: null,
        data: tollFreeStatus[sid] ?? {
          status: null,
          tollfreePhoneNumberSid: sid,
        },
      }

    const numberMeta = state.locationTwilio?.numberMeta[phoneNumber]
    const inHighLevelDB = Boolean(state.locationTwilio?.numbers[phoneNumber])
    const tollFreeAPIStatus = tollFreeStatus[sid]?.status ?? numberMeta?.tollFreeStatus
    const metaStatus = numberMeta?.tollFreeStatus
    const isUnderGHL =
      state.locationTwilio?.underGHLAccount ??
      state.locationTwilio?.under_ghl_account

    const decisions = {
      numberMeta: numberMeta,
      numberNotMeta: !numberMeta,
      inHighLevelDB: inHighLevelDB,
      notInHighLevelDB: !inHighLevelDB,
      hasTollFreeAPIStatus: tollFreeAPIStatus,
      hasNoTollFreeAPIStatus: !tollFreeAPIStatus,
      hasMetaStatus: metaStatus,
      hasNoMetaStatus: !metaStatus,
      isUnderGHL: isUnderGHL,
      isNotUnderGHL: !isUnderGHL,
    }

    const decisionTree = {
      isUnderGHL: {
        inHighLevelDB: {
          hasTollFreeAPIStatus: () => tollFreeAPIStatus,
          hasNoTollFreeAPIStatus: {
            hasMetaStatus: () => metaStatus,
            hasNoMetaStatus: () => REQUIRED,
          },
        },
        notInHighLevelDB: () => null,
      },
      isNotUnderGHL: () => null,
    }

    const result = evaluateDecisionTree(decisionTree, decisions)
    const fallbackData = {
      status: result,
      tollfreePhoneNumberSid: sid,
    }

    return {
      status: result,
      data: tollFreeStatus[sid] ?? fallbackData,
    }
  }
}

export default getTollFreeData
